import { Col, FormItemProps, message } from "antd";
import { BaseApiResponseModel } from "api/model/BaseApiResponseModel";
import { PaginationsProps } from "api/model/Paging";
import { UserFeatureResponseModel } from "api/repositories/users/model/feature/UserFeatureResponseModel";
import { SelectOps } from "components/generalComponents/filterComponents/interface/IFilterComponent";
import { isEmpty, isNull, isUndefined } from "lodash";
import { Dispatch, SetStateAction } from "react";
import { strings } from "./localizeStrings";

export const getMessage = (
  info: string,
  time: number,
  type: "success" | "error" | "warning" | "info"
) => {
  message?.destroy();
  switch (type) {
    case "info":
      return message.info({
        content: info,
        duration: time,
      });
    case "success":
      return message.success({
        content: info,
        duration: time,
      });
    case "error":
      return message.error({
        content: info,
        duration: time,
      });
    case "warning":
      return message.warning({
        content: info,
        duration: time,
      });
  }
};

export const DescriptionLabels = (
  key: string,
  labels: Record<string, string>
) => {
  let test = Object.entries(labels)?.map(([labelKey, labelVal]) => {
    return {
      label: labelKey,
      value: labelVal,
    };
  });
  do {
    let finalLabels = test?.filter(
      (item) => item?.label === key && item?.value
    );
    return finalLabels[0]?.value as string;
  } while (!isEmpty(test) || test !== undefined);
};

export const createFormRules = (
  stricted: boolean,
  dataType: string,
  message: string
) => {
  return [
    {
      required: stricted,
      type: dataType,
      message: message,
    },
  ] as FormItemProps["rules"];
};

export const getFormInitialVals = <O extends Object>(
  data: O,
  value: keyof O
) => {
  if (!isEmpty(data)) {
    return data[value];
  } else {
    return undefined;
  }
};

export const labelsRender = (label: string) => {
  return (
    <Col span={24} className="text-center">
      <b style={{ fontSize: 16 }}>{label}</b>
    </Col>
  );
};

export const DataFormater = (number: number) => {
  if (number >= 1000000000) {
    return (number / 1000000000).toString() + " Tỷ";
  } else if (number >= 1000000) {
    return (number / 1000000).toString() + " Triệu";
  } else if (number >= 1000) {
    return (number / 1000).toString() + " Ngàn";
  } else {
    return number.toString();
  }
};

export const handleTableChange = async <T extends Object>(data: {
  pagination?: PaginationsProps | any;
  paramsExport: T;
  needCallbackFunction: boolean;
  apiCallbackFunction?: (value?: T) => Promise<void>;
  setPage: Dispatch<SetStateAction<number>>;
  setPageSize: Dispatch<SetStateAction<number>>;
}) => {
  const {
    setPage,
    setPageSize,
    apiCallbackFunction,
    pagination,
    paramsExport,
    needCallbackFunction,
  } = data;
  setPage(pagination?.current! - 1);
  setPageSize(pagination?.pageSize!);
  if (needCallbackFunction === true) {
    let params: typeof paramsExport = {
      ...paramsExport,
      page: pagination?.current! - 1,
      limit: pagination?.pageSize!,
    };
    await apiCallbackFunction!(params);
  }
};

export const selectFilterOption = (input: string, options: SelectOps) => {
  if (
    options?.label?.toLowerCase().includes(input.toLowerCase()) ||
    options?.value.toString() === input.toString().toLowerCase()
  ) {
    return true;
  }
  return false;
};

export const paramsChecking = <T extends unknown>(
  value: T | undefined,
  type: "select" | "input"
) => {
  switch (type) {
    case "select":
      return value === strings.GlobalMessage.All ? undefined : value;
    case "input":
      return isEmpty(value) || isUndefined(value) ? undefined : value;
  }
};

export const fetchResponseList = async <
  RequestModel extends Object,
  ResponseModel extends Object[]
>(data: {
  params: RequestModel;
  loadingState: Dispatch<SetStateAction<boolean>>;
  responseState: Dispatch<SetStateAction<ResponseModel>>;
  totalState?: Dispatch<SetStateAction<number>>;
  getListFunction: (
    params: RequestModel
  ) => Promise<BaseApiResponseModel<ResponseModel>>;
}) => {
  const { params, responseState, loadingState, getListFunction, totalState } =
    data;
  try {
    loadingState(true);
    const res = await getListFunction(params);
    if (res) {
      responseState(res?.data);
      totalState!(res?.paging?.total!);
    }
  } catch (error) {
    console.log(error);
    getMessage(`${strings.GlobalMessage.Error}${error?.message}`, 4, "error");
  } finally {
    loadingState(false);
  }
};

export const renderEclipse = (
  value: string | number,
  clickToCopy: boolean = false
) => {
  return !isNull(value) && !!value ? (
    <span
      style={{ color: "#0f0f0f" }}
      onClick={async () => {
        if (clickToCopy === true) {
          await window?.navigator?.clipboard?.writeText(value as string);
          getMessage(strings.GlobalMessage.CopiedInfo, 3, "success");
        }
      }}
    >
      {value}
    </span>
  ) : (
    <span>{strings.GlobalLabels.NoInfo}</span>
  );
};

export const avoidDuplicate = (baseInfo: unknown, newInfo: typeof baseInfo) => {
  if (newInfo === baseInfo) {
    return undefined;
  } else {
    return newInfo;
  }
};

export function areEqual(arr1: Array<any>, arr2: Array<any>) {
  let N = arr1.length;
  let M = arr2.length;

  if (N !== M) return false;

  arr1.sort();
  arr2.sort();

  for (let i = 0; i < N; i++) if (arr1[i] !== arr2[i]) return false;
  return true;
}

export const findElement = (
  keyword: string,
  array: UserFeatureResponseModel[]
) => {
  if (array?.find((item) => item?.code === keyword)) {
    return true;
  } else {
    return undefined;
  }
};

export const getKeyByValue = (
  object: Record<string, unknown>,
  value: string
) => {
  return Object.keys(object)?.find((key) => object[key] === value) ?? undefined;
};
